import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";




const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "Non renseigné"; 
    var cleanNumber = parseInt(phoneNumber).toString().replace(/[^\d]/g, '');
    if (cleanNumber.length === 9) {
        cleanNumber = '0' + cleanNumber;
    }

    if (cleanNumber.length === 10) {
        return cleanNumber.replace(/(\d{2})(?=\d)/g, "$1 ").trim(); 
    } else {
        return phoneNumber; 
    }
    };


const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371; 
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c).toFixed(1); 
    };



const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const Telecharger_Rapport_PDF = async ({
    coordonnéesPointCentral,
    setCoordonnéesPointCentral,
    filteredData,
    selectedSousCategories,
    selectedProfessions,
    setAfficherCercleDeRecherche,
    Recuperer_adresse_avec_coord,
    praticiensData,
}) => {
    setCoordonnéesPointCentral({
        lat: coordonnéesPointCentral.lat,
        lng: coordonnéesPointCentral.lng,
    });

    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    const title = "Récapitulatif de la recherche";
    const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
    const x = (doc.internal.pageSize.width - titleWidth) / 2;
    doc.text(title, x, 15);

    doc.setFontSize(12);
    const categoriesLabel = filteredData.length > 0 ? "Catégories recherchées :" : "Professions recherchées :";
    doc.text(categoriesLabel, 15, 50);

    doc.setFont("helvetica", "italic");
    const categoriesText = filteredData.length > 0
        ? selectedSousCategories.join(", ")
        : selectedProfessions.join(", ");
    const pageWidth = doc.internal.pageSize.width / 2.5;
    const wrappedCategoriesText = doc.splitTextToSize(categoriesText, pageWidth);
    doc.text(wrappedCategoriesText, 15, 55);

    
    const mapElement = document.querySelector(".leaflet-container");
    if (mapElement) {
        setAfficherCercleDeRecherche(false);
        await wait(300);

        const captureWidth = mapElement.clientWidth * 0.7;
        const captureHeight = mapElement.clientHeight * 0.9;

        const captureX = (mapElement.clientWidth - captureWidth) / 2;
        const captureY = (mapElement.clientHeight - captureHeight) / 2;
        await wait(500)
        const canvas = await html2canvas(mapElement, {
            useCORS: true,
            x: captureX,
            y: captureY,
            width: captureWidth,
            height: captureHeight,
        });

        await wait(300);
        setAfficherCercleDeRecherche(true);

        const imgData = canvas.toDataURL("image/png");

        const imgX = doc.internal.pageSize.width / 2;
        const imgY = 45;

        const imgWidth = doc.internal.pageSize.width / 2 - 15;
        const imgHeight = doc.internal.pageSize.height / 5.5;

        doc.addImage(imgData, "PNG", imgX, imgY, imgWidth, imgHeight);
    }

    const userAddress = await Recuperer_adresse_avec_coord(coordonnéesPointCentral);
    const userAddressText = ` ${userAddress}`;
    const wrappedAddressText = doc.splitTextToSize(userAddressText, pageWidth);

    const addressStartY = 60 + wrappedCategoriesText.length * 5;
    doc.setFont("helvetica", "bold");
    doc.text("Votre adresse : ", 15, addressStartY);
    doc.setFont("helvetica", "italic");
    doc.text(wrappedAddressText, 15, addressStartY + 5);

    if (filteredData.length > 0) {
        const groupedData = filteredData.reduce((acc, item) => {
            const { nom, adresse_finale, telephone, sous_categorie, coords } = item;
            const distance = coords
                ? calculateDistance(coordonnéesPointCentral.lat, coordonnéesPointCentral.lng, coords[0], coords[1])
                : null;

            const formattedPhone = telephone;

            if (!acc[sous_categorie]) {
                acc[sous_categorie] = [];
            }

            acc[sous_categorie].push([
                nom || "Non renseigné",
                adresse_finale || "Non renseignée",
                formattedPhone,
                distance !== null ? `${distance} km` : "N/A",
                distance,
            ]);
            return acc;
        }, {});

        Object.keys(groupedData).forEach((category, index) => {
        
            if (index > 0) {
                doc.addPage();
            }

            const categoryData = groupedData[category];

            // Trier par distance numérique (si distance est "N/A", on place en dernier)
            categoryData.sort((a, b) => {
                const distanceA = a[4] === null ? Infinity : a[4];
                const distanceB = b[4] === null ? Infinity : b[4];
                return distanceA - distanceB;
            });

            doc.setFontSize(14);
            
            doc.text(category, 14,  index===0 ? 120 : 30);
            //Pour placer le symbole du marqueur à côté de la catégorie
            const textWidth = doc.getTextWidth(category);
            const imgX = 14 + textWidth + 5;  
            const imgY = index===0 ? 113 : 23;
            const imgWidth = 10;  
            const imgHeight = 10; 
            doc.addImage(`marqueurs_finaux_finess/${category}.png`, 'PNG', imgX, imgY, imgWidth, imgHeight);
            let startY = index===0 ? 130 : 40;

            // Ajouter le tableau pour cette catégorie
            doc.autoTable({
                head: [["Nom", "Adresse", "Téléphone", "Distance"]],
                body: categoryData.map(row => row.slice(0, 4)),
                startY,
                styles: {
                    fontSize: 9,
                    cellPadding: 3, 
                    halign: 'center',
                    valign: 'middle',
                    overflow: 'linebreak', 
                    columnWidth: 'auto',  
                },
                headStyles: { fillColor: [52, 152, 219] },
                columnStyles: {
                    1: { 
                        cellPadding: 1,
                        overflow: 'linebreak', 
                    },
                    2: { 
                        halign: 'center',
                        columnWidth: 'auto',
                    },
                },
                pageBreak: 'auto', 
            });
            
        });
    } else {
        const groupedByProfession = praticiensData.reduce((acc, item) => {
            const { nom, prenom, adresse, telephone, profession, coords } = item;
            const distance = coords
                ? calculateDistance(coordonnéesPointCentral.lat,coordonnéesPointCentral.lng, coords[0], coords[1])
                : null;

            const formattedPhone = formatPhoneNumber(telephone);

            // Grouper par profession
            if (!acc[profession]) {
                acc[profession] = [];
            }

            acc[profession].push([
                `${prenom} ${nom}`,
                adresse || "Non renseignée",
                formattedPhone,
                distance !== null ? `${distance} km` : "N/A",
                distance,
            ]);
            return acc;
        }, {});

        Object.keys(groupedByProfession).forEach((profession, index) => {
            if (index > 0) {
                doc.addPage();
            }

            const professionData = groupedByProfession[profession];

            professionData.sort((a, b) => {
                const distanceA = a[4] === null ? Infinity : a[4];
                const distanceB = b[4] === null ? Infinity : b[4];
                return distanceA - distanceB;
            });

            doc.setFontSize(14);
            
            doc.text(profession, 14, index===0 ? 100 : 30);
            const textWidth = doc.getTextWidth(profession);
            const imgX = 14 + textWidth + 5;  
            const imgY = index===0 ? 113 : 23;
            const imgWidth = 10;  
            const imgHeight = 10; 
            doc.addImage(`logos_marianne_PS/${profession}.png`, 'PNG', imgX, imgY, imgWidth, imgHeight);
            let startY = index===0 ? 110 : 40;

            doc.autoTable({
                head: [["Nom", "Adresse", "Téléphone", "Distance"]],
                body: professionData.map(row => row.slice(0, 4)),
                startY,
                styles: {
                    fontSize: 9,
                    cellPadding: 0,
                    halign: 'center',
                    valign: 'middle',
                    overflow: 'linebreak', 
                    columnWidth: 'wrap',
                },
                headStyles: { fillColor: [52, 152, 219] },
                columnStyles: {
                    1: { 
                        cellPadding: 1,
                        overflow: 'linebreak', 
                    },
                    2: { 
                        columnWidth: 30, 
                        cellPadding: 1,
                        halign: 'center',
                        overflow: 'visible', 
                    },
                },
            });
            
        });
    }

    doc.save("recapitulatif-sante.pdf");
};
